import React, { CSSProperties } from "react";
import SimpleButton from "../buttons/Simple-button";
import H3 from "../typography/H3";
import "./empty-state.css";
import { is } from "date-fns/locale";
import tr from "date-fns/locale/tr";

interface EmptyStateProps {
  icon: any;
  heading?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  isButton?: boolean;
  style?: CSSProperties;
  className?: string; // ✅ Added
  isBorder?: boolean;
  bodytext?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  heading,
  buttonLabel,
  onButtonClick,
  isButton = true,
  style = {},
  className = "",
  isBorder = true,
  bodytext = "",
}) => {
  return (
    <div
      className={`${isBorder ? "empty-state-card-border" : "empty-state-card"} ${className}`}
      style={{ ...style }}
    >
      <div className="d-flex flex-column align-items-center justify-content-center gap-2">
        <div className="emptyState-icon-circle">
          <img
            className="image-icon color-white-icon"
            src={icon}
            alt="Icon"
          />
        </div>
        <H3 text={heading} />
        {isButton && (
          <SimpleButton label={buttonLabel} onClick={onButtonClick} />
        )}
        {bodytext && (
          <div className="emptyState-bodytext mt-2">
            <p className="empty-state-bodytext">{bodytext}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
